import React from 'react';
import { Views } from 'react-big-calendar';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';

import { Calendar, CalendarConnector, CalendarEventCard } from '../calendar';

export const WeekCalendar = () => (
  <CalendarConnector
    period={CalendarEventsPeriod.Week}
    children={props => (
      <Calendar
        step={15}
        timeslots={3}
        view={Views.WEEK}
        views={[Views.WEEK]}
        components={{
          event: props => <CalendarEventCard showMore {...props} />,
        }}
        {...props}
      />
    )}
  />
);
